module.exports = __webpack_public_path__ + "static/blurple-83fc84804a4d03e945ec5a7f94db5b9a.png";